import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const RESOURCES = Resources.Admin.Raffle.Validation;

/** Ticket numbers run from 1 to the round's ticket count, which is known once the close numbers them. */
export const getRaffleHolderLookupSchema = (
  t: TFunction,
  ticketCount: number | null | undefined,
) => {
  const message =
    ticketCount == null
      ? t(RESOURCES.TicketNumberInvalid)
      : t(RESOURCES.TicketNumberRange, { max: ticketCount });
  const ticketNumber = z.number().int(message).min(1, message);

  return z.object({
    ticketNumber:
      ticketCount == null
        ? ticketNumber
        : ticketNumber.max(ticketCount, message),
  });
};

export type RaffleHolderLookupFormData = z.infer<
  ReturnType<typeof getRaffleHolderLookupSchema>
>;
